
































































































import FooterButton from "@/components/FooterButton.vue";
import { Component, Mixins } from "vue-property-decorator";
import { AppData } from "@/models/app-data";
import CommonMixin from "@/mixins/common-mixins";
import { ContentService } from "@/service/content.service";
import { GSRPPickProgramsContent } from "@/models/content/gsrp-pick-programs";

@Component({
  components: {
    FooterButton,
  },
})
export default class GSRPPickPrograms extends Mixins(CommonMixin) {
  content: GSRPPickProgramsContent = {} as GSRPPickProgramsContent;
  headStartChecked = false;
  greatStartChecked = false;
  appData = {} as AppData;
  textDirection = "ltr";
  checkTextAlign = "has-text-left";

  async mounted(): Promise<void> {
    try {
      const contentService = new ContentService(this.$route);
      this.content = await contentService.getGSRPPickProgramsContent();
      this.textDirection = contentService.TextDirection();
      if (this.textDirection == "rtl") {
        this.checkTextAlign = "has-text-right";
      }
      this.appData = this.getAppData();

      if (this.appData != null) {
        this.headStartChecked = this.appData.applyHeadStart ?? false;
        this.greatStartChecked = this.appData.applyGreatStart ?? true;
        this.putWorkflowStep( this.appData.workflowId, "GSRPPickPrograms") 
      }
    } catch (error) {
      this.showError(error);
    }
  }

  public handleNextPageEvent(): void {
    if (this.appData == null) {
      this.appData = {} as AppData;
    }
    this.appData.applyHeadStart = this.headStartChecked;
    this.appData.applyGreatStart = this.greatStartChecked;

    this.saveAppData(this.appData);
    this.$router.push({ path: "CareGiver1" });
  }

  disableNext(): boolean {
    return !(this.headStartChecked || this.greatStartChecked);
  }
}
